
import Vue from "vue";
import Chartkick from "vue-chartkick";
import Chart from 'chart.js'

Chart.pluginService.register({
    beforeDraw: function (chart) {
        if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
            //var helpers = Chart.helpers;
            let ctx = chart.chart.ctx;
            let chartArea = chart.chartArea;

            ctx.save();
            ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
            ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            ctx.restore();
        }
    }
});

let ChartAnnotation=require('chartjs-plugin-annotation');
Chart.pluginService.register(ChartAnnotation);

Vue.use(Chartkick.use(Chart))